// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";

class InputArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      touched: false,
      value: this.props.value
    };
  }

  getInputState() {
    const { required, requiredMessage, t } = this.props;
    const invalidInput = {
      hasError: true,
      style: {
        backgroundColor: "#fff0f0",
        borderColor: "#A90329"
      }
    };
    const validInput = {
      hasError: false,
      style: {
        backgroundColor: "#f0fff0",
        borderColor: "#7DC27D"
      }
    };
    const neutralInput = { hasError: false, style: {} };
    return this.state.touched
      ? this.state.value
        ? validInput
        : required
        ? {
            ...invalidInput,
            errorMessage:
              requiredMessage ||
              t("modules.localization.register.authenticated.error.invalidFields.default")
          }
        : neutralInput
      : neutralInput;
  }

  render() {
    const { iconClass, label, placeholder, rows, toolTip } = this.props;
    const inputState = this.getInputState();
    return (
      <section>
        {label && <label className="label">{label}</label>}
        <label className="input">
          <label className="textarea">
            <i className={iconClass} />
            <textarea
              onBlur={() => this.setState({ touched: true })}
              onChange={(e) => this.setState({ value: e.target.value })}
              placeholder={placeholder}
              rows={rows}
              style={{ ...inputState.style }}
            />
            {toolTip && (
              <b className="tooltip tooltip-top-right">
                <i className="fa fa-user txt-color-teal" />
                {toolTip}
              </b>
            )}
          </label>
          <em className="invalid" style={{ height: 30, minHeight: 30 }}>
            {inputState.hasError && inputState.errorMessage}
            &nbsp;
          </em>
        </label>
      </section>
    );
  }
}

InputArea.defaultProps = {
  placeholder: "",
  rows: 3,
  required: false,
  value: ""
};

InputArea.propTypes = {
  iconClass: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  requiredMessage: PropTypes.string,
  rows: PropTypes.number,
  t: PropTypes.func.isRequired,
  toolTip: PropTypes.string,
  value: PropTypes.string
};

export default withNamespaces()(InputArea);
